module.exports = __webpack_public_path__ + "static/img/img_logo_3.9f5ba0fb.png";